import React from "react";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router-dom";
import pic from "../assets/images/Logo-2.png";
import { saveUser } from "../redux/actions/action";

const Dashboard = () => {
  const dispatch = useDispatch()
  return (
    <>
      <nav
        className="navbar navbar-expand-lg navbar-light"
        style={{ background: "#a3a3a3", display: "block" }}
      >
        <div className="row">
          <div className="col-md-3" style={{ textAlign: "center" }}>
            <img
              style={{ width: "150px" }}
              className="img-responsive"
              src={pic}
            />
          </div>
          <div className="col-md-9" style={{ marginTop: "-13px" }}>
            <a className="navbar-brand" href="#"></a>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav mr-auto">
                <li className="nav-item">
                  <a className="nav-link" href="/dashboard">
                    Users <span className="sr-only"></span>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/dashboard/status">
                    Status <span className="sr-only"></span>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/dashboard/notes">
                    Notes <span className="sr-only"></span>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/dashboard/chats">
                    Chats <span className="sr-only"></span>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/dashboard/news">
                    News <span className="sr-only"></span>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/dashboard/notification">
                    Notification <span className="sr-only"></span>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/dashboard/cricketGears">
                    Cricket Gears <span className="sr-only"></span>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" 
                  href="/"
                  onClick={()=>{
                    dispatch(saveUser(false))
                  }}>
                    Logout <span className="sr-only"></span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
      <Outlet />
    </>
  );
};

export default Dashboard;
